/**
 * Advisor ツール結果の型定義とユーティリティ
 *
 * desktop-app / web の両パッケージで共通利用する。
 */
export function isAdvisorResult(result) {
    if (!result || typeof result !== 'object')
        return false;
    const r = result;
    return r.status === 'success' || r.status === 'error' || r.status === 'limit_reached';
}
//# sourceMappingURL=advisor-result.js.map